export default __webpack_public_path__ + "static/media/header.d9483826.png";